export default class HtmlElementHelper {
    static g_elementExists(id: string) {
        const element = document.getElementById(id);
        return typeof (element) !== 'undefined' && element !== null;
    };

    static g_blockUI() {
        (<any>window).FreezeUI({ text: ' ' });
    }

    static g_unBlockUI() {
        (<any>window).UnFreezeUI();
    }

    static g_deleteErrorMessage(input: HTMLElement) {
        const validationId = "advice-required-entry-" + input.id;
        const element = document.querySelector(`#${validationId}`);
        if (element)
            element.remove();
    }

    static g_addErrorMessage(input: HTMLElement, errorMessage: string) {
        const validationId = `advice-required-entry-${input.id}`;
        const el = document.querySelector(`#${validationId}`);
        if (!el) {
            const validationAdvice = document.createElement('div');
            validationAdvice.className = "validation-advice";
            validationAdvice.id = validationId;
            validationAdvice.style.marginTop = "-10px";
            validationAdvice.style.marginBottom = "20px";
            validationAdvice.innerHTML = errorMessage;

            const inputParent = input.parentElement?.parentElement;
            if (inputParent) {
                inputParent.after(validationAdvice);
                validationAdvice.style.display = "block";
            }
        } else {
            el.innerHTML = errorMessage;
        }
    }
    
    static Hide(selectors: string) {
        const elements = document.querySelectorAll(selectors);
        elements.forEach((el: HTMLElement)=> {
            el.style.display = 'none';
        });
    }

    static HideEl(element: HTMLElement) {
        element.style.display = 'none';
    }

    static Show(selectors: string) {
        const elements = document.querySelectorAll(selectors);
        elements.forEach((el: HTMLElement)=> {
            el.style.display = 'block';
        });
    }

    static ShowEl(element: HTMLElement) {
        element.style.display = 'block';
    }

    static FadeIn(selectors: string) {
        let elements: NodeListOf<Element> = document.querySelectorAll(selectors);
        for(let i = 0; i < elements.length; i++) {
            const el = elements[i] as HTMLElement;
            let op: number = 0.1;  // initial opacity
            el.style.display = 'block';
            let timer = setInterval(function () {
                if (op >= 1){
                    clearInterval(timer);
                }
                el.style.opacity = op.toString();
                el.style.filter = 'alpha(opacity=' + op * 100 + ")";
                op += op * 0.1;
            }, 10);
        }
    }

    static FadeOut(selectors: string) {
        let elements: NodeListOf<Element> = document.querySelectorAll('.overlay-holder');
        for(let i = 0; i < elements.length; i++) {
            const el = elements[i] as HTMLElement;
            el.style.display = 'block';
            let op = 1;  // initial opacity
            let timer = setInterval(function () {
                if (op <= 0.1){
                    el.style.display = 'none';
                    clearInterval(timer);
                }
                el.style.opacity = op.toString();
                el.style.filter = 'alpha(opacity=' + op * 100 + ")";
                op -= op * 0.1;
            }, 50);
        }
    }
    
    static addHidden(theForm: HTMLFormElement, key: string, value: string): void {
        // Create a hidden input element, and append it to the form:
        const input: HTMLInputElement = document.createElement('input');
        input.type = 'hidden';
        input.name = key; // 'the key/name of the attribute/field that is sent to the server
        input.value = value;
        theForm.appendChild(input);
    }
}